<template>
  <div id="likeLayout">
    <b-modal :active.sync="isImageModalActive">
      <img :src="this.ImageModalSrc">
    </b-modal>

    <!-- MENU HEADER  -->
    <div class="tools">

      <div class="title">
        <img src="~@/assets/public_logo.png">
        <h1 class="">{{ current.name }}</h1>
      </div>

      <div class="rightMenu">

      </div>

    </div>
    <!-- FIN MENU HEADER -->

    <!-- ZONE CONTENANT LES POSTITS TRIES -->
    <div
      class="contentLayout"
      id="svgBoard"
    >
      <ul class="zonepostsit">
        <transition-group name="flip-list">
          <li
            class="gabaritPostLike"
            v-for="post in trashedPosts"
            :key="post.id"
          >
            <div
              class="bandeauPostLike"
              :style="'background-color:'+post.couleur"
            >
              <a
                @click="openPopupLink(post)"
                :class="{non_active: !post.link}"
              >
                <b-icon
                  class="editbutton"
                  pack="fas"
                  icon="link"
                  size="is-small"
                ></b-icon>
              </a>
              <a
                @click="loadImagePopup(url_media+'uploads/brainstorming/medias/'+post.media)"
                :class="{non_active: !post.media}"
              >
                <b-icon
                  class="editbutton"
                  pack="fas"
                  icon="image"
                  size="is-small"
                ></b-icon>
              </a>
              <b-icon
                class="likebutton"
                pack="far"
                icon="heart"
                size="is-small"
              ></b-icon> {{ post.like }}
              <b-tooltip
                position="is-right"
                :label="$t('tooltip.restore')"
              >
                <a @click="restorePost(post)">
                  <b-icon
                    pack="fas"
                    icon="arrow-up"
                    size="is-small"
                  ></b-icon>
                </a>
              </b-tooltip>
            </div>
            <div class="contenuPostLike">
              {{post.contenu}}
            </div>
          </li>
        </transition-group>
      </ul>

      <div class="clearfix"></div>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
export default {
  data () {
    return {
      trashedPosts: null,
      FiltreActifColor: '',
      FiltreActifSheet: null,
      currentFilteredColor: null,
      currentFilteredSheet: null,
      imageUrl: '',
      ImageModalSrc: null,
      isImageModalActive: false,
      loaded: false,
      url_media: process.env.URL_MEDIA,
      colors: [
        'rgb(112,209,248)',
        'rgb(238,110,110)',
        'rgb(96,205,199)',
        'rgb(245,235,153)',
        'rgb(223,173,53)',
        'rgb(96,76,141)',
        'rgb(76,108,160)'
      ]
    }
  },
  computed: {
    ...mapState({
      current: 'current',
      postlist: 'trashedBoardPost'
    })
  },
  created () {
  },

  watch: {
    current: {
      handler: function (val) {
        if (this.current.id !== undefined && this.loaded === false) {
          this.loaded = true
          var data = { board: this.current }
          this.$store.dispatch('board/loadBoardData', data)
          this.getTrashedPosts()

          var room = 'Room_Brain_' + this.current.id
          this.$socket.emit('room', room)

          if (this.current.template_id !== null) { document.getElementById('svgBoard').setAttribute('style', "background:url('" + process.env.URL_MEDIA + this.current.template.url + "')no-repeat 0% 0%;background-size:100%;") } else { document.getElementById('svgBoard').setAttribute('style', 'background: url("/static/quadrillage.png") repeat scroll 0% 0%') }
        }
      },
      deep: true,
      immediate: true
    },
    postlist: {
      handler: function (val) {
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async restorePost (post) {
      try {
        // Default options are marked with *
        let res = await fetch(`${process.env.URL_SSO_API}brainstorming/board/restore`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'urlparticipant': this.current.url_participant
          },
          body: JSON.stringify({ postId: post.id, board_id: this.current.id })
        })

        this.trashedPosts = await res.json()
      } catch (error) {

      }
    },
    async getTrashedPosts () {
      let res = await fetch(`${process.env.URL_SSO_API}brainstorming/public/board/${this.current.id}/trashed`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          //   'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, Authorization, urlparticipant, urlmoderateur',
          'urlparticipant': this.current.url_participant

          // 'Content-Type': 'application/x-www-form-urlencoded',
        }
      })
      this.trashedPosts = await res.json()
    },
    even: function (arr) {
      var postsRetour = arr

      /* Permet de n'afficher que les postit appartenant à une feuille existante (traitement du cas de suppresion de feuille) */
      if (this.$store.state.board.current.sheets != undefined) {
        var feuillesPossibles = []
        this.trashedPosts.forEach(function (element) {
          feuillesPossibles.push(element.id)
        })
        postsRetour = postsRetour.filter(p => feuillesPossibles.indexOf(p.sheet_id) != -1)
      }
      /* fin du traitement */

      if (this.FiltreActifColor) { postsRetour = postsRetour.filter(p => p.couleur === this.FiltreActifColor) }
      if (this.FiltreActifSheet) { postsRetour = postsRetour.filter(p => p.sheet_id === this.FiltreActifSheet) }

      return postsRetour.slice().sort(function (a, b) {
        return b.like - a.like
      })
    },
    openPopupLink (lePost) {
      if (lePost.link.length > 40) { lePost.messagePopup = lePost.link.substr(0, 40) + '...' } else { this.messagePopup = lePost.link }
      this.$buefy.dialog.confirm({
        title: this.$i18n.t('post.link.popup.title'),
        message: this.$i18n.t('post.link.popup.message') + '<br><br>' + this.messagePopup,
        type: 'is-info',
        cancelText: this.$i18n.t('post.link.popup.non'),
        confirmText: this.$i18n.t('post.link.popup.oui'),
        hasIcon: true,
        onConfirm: () => window.open(lePost.link, '_blank')
      })
    },
    loadImagePopup (mediaURL) {
      if (mediaURL) {
        this.ImageModalSrc = mediaURL
        this.isImageModalActive = true
      }
    },
    filterColor (color) {
      this.currentFilteredColor = color
      if (color) {
        this.FiltreActifColor = color
      } else {
        this.FiltreActifColor = ''
      }
    },
    filterSheet (sheet) {
      if (sheet) {
        this.currentFilteredSheet = sheet.name
        this.FiltreActifSheet = sheet.id
      } else {
        this.currentFilteredSheet = null
        this.FiltreActifSheet = null
      }
    }

  },
  sockets: {
    connect () {
      // console.log('connect')
      this.$store.commit('board/SOCKET_STATE', { state: true })
    },
    disconnect () {
      this.$store.commit('board/SOCKET_STATE', { state: false })
    },
    channel (data) {
      var decodeddata = JSON.parse(decodeURIComponent(data))
      if (decodeddata.type === 'CREATE') {
        this.$store.commit('board/NEW_POST', decodeddata.post)
      } else if (decodeddata.type === 'UPDATE') {
        this.$store.commit('board/UPDATE_POST', decodeddata.post)
      } else if (decodeddata.type === 'NEW_SHEET') {
        this.$store.commit('board/NEW_SHEET', decodeddata.post)
      } else if (decodeddata.type === 'DESTROY_SHEET') {
        this.$store.commit('board/REMOVE_SHEET', decodeddata.post)
      } else if (decodeddata.type === 'UPDATE_SHEET') {
        this.$store.commit('board/UPDATE_SHEET', decodeddata.post)
      }
    }
  }

}
</script>

<style scoped>
.clearfix {
  clear: both;
}

.zonepostsit {
  padding-top: 70px;
}

.gabaritPostLike {
  float: left;
  background: white;
  width: 250px;
  min-height: 60px;
  position: relative;
  z-index: 1;
  border-radius: 5px;
  margin: 10px;
}

.bandeauPostLike {
  padding: 0px 5px;
  border-radius: 5px 5px 0 0;
}

.contenuPostLike {
  padding: 5px 15px;
  font-size: 0.9em;
}

.contentLayout {
  position: relative;
  min-height: 100%;
  width: 100%;
}

#likeLayout {
  width: 100%;
  height: 100%;
}

/* barre outils */
.tools {
  width: 100%;
  z-index: 9;
  margin: auto;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgb(62, 106, 153);
  border-radius: 0;
  padding: 8px 5px;
  height: 60px;
}
.rightMenu {
  display: inline-block;
  width: 55%;
  text-align: right;
  vertical-align: top;
}
.rightMenu > * {
  margin: 0 4px;
}
.title {
  color: white;
  float: left;
  margin: 0;
  width: 40%;
  font-size: 18px;
  margin: 0 0 0 5px;
  text-align: left;
}
.title > img {
  display: inline-block;
  vertical-align: top;
  max-width: 5%;
}
.title > h1 {
  display: inline-block;
  padding: 0px 0 0 10px;
  width: 90%;
}
.colorfilter,
.sheetfilter {
  display: inline-block;
  vertical-align: top;
  z-index: 100;
  margin: 0 0 0 0;
}

.non_active {
  opacity: 0.3;
  pointer-events: none;
}
.editbutton {
  color: black;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.editbutton:hover {
  color: #fff;
}

.flip-list-move {
  transition: transform 1s;
}

.flip-list-item {
  transition: all 1s;
  /* display: inline-block;*/
}
.flip-list-enter,
.flip-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.flip-list-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/TrashedPosts.vue